export enum AttachmentAppearance {
  PLACEHOLDER = 'placeholder',
  DEFAULT = 'default',
  EXTERNAL = 'external',
}
